import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { TextField } from "react-admin";
import enums from "../../Enums/index";
/**
 * @example
 *  <EnumField label={'Enum'} enumName={'GetCarrierType'} source={'enumTest'} variant={'outlined'} />
 *  <EnumField label={'Enum'} enumName={'GetCarrierType'} defaultValue={CarrierType.DHL} source={'enumTest'} variant={'outlined'} />
 * */
interface IKeyValuePair {
  Value: Number;
  Description: string;
}
export const EnumField = props => {
  const { enumName, source, record, ...rest } = props;
  const [choices, setChoices] = useState<IKeyValuePair[]>([]);
  const [value, setValue] = useState("");
  useEffect(() => {
    const enumValueList = enums[enumName];
    let tempChoices: IKeyValuePair[] = [];
    if (enumValueList?.length > 0) {
      tempChoices = enumValueList.map((x: any) => {
        const element: IKeyValuePair = {
          Value: x.Value,
          Description: x.Description,
        };
        return element;
      });
    } else {
      for (var enumValue in enumValueList) {
        if (isNaN(Number(enumValue))) {
          var result = enumValue?.replace?.(/([A-Z])/g, " $1");
          var finalResult = result?.charAt?.(0)?.toUpperCase?.() + result?.slice?.(1);
          tempChoices.push({
            Value: Number(enumValueList[enumValue]),
            Description: finalResult || enumValue,
          });
        }
      }
    }
    setChoices(tempChoices || []);
  }, []);
  useEffect(() => {
    const sources = source.split(".");
    let enumValue: any = record;
    for (let i = 0; i < sources.length; i++) {
      const source = sources[i];
      enumValue = enumValue?.[source];
    }
    let enumDesc = choices?.find?.(x => x.Value === enumValue)?.Description || "";
    setValue(enumDesc);
  }, [record, choices]);

  return <TextField source={"enumValue"} record={{ ...record, enumValue: value }} {...rest} />;
};

EnumField.propTypes = {
  enumName: PropTypes.string.isRequired,
  ...TextField.prototype,
};

EnumField.defaultProps = {};

export default EnumField;
